import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { Helper } from '../helpers/helper';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';


@Component({
  selector: 'echexpayment-echexbase',
  templateUrl: './echexbase.component.html',
  //styleUrls: ['./echexbase.component.css']
})
export class EchexbaseComponent {
	
	busy: Subscription;
	public token: string;
	public user_token: string;
	public user_id: string;
	public check_number: string;
	public profile: any = {};
	profileBankDetails: any = {};
	sendCheck: any = {};
	profileSettings: any = {};
	public twofactorStatus :boolean;
	public bankname: string;
	public bankaddress: string;
	public bankcity: string;
	public bankzip: string;
	//bank details show edit button
	public show_edit_signature: boolean=false;
	public hide_signature_tab: boolean=true;

	public draw_it:boolean=false;
	public type_it:boolean=false;
	public merchantImg_url: string;
	public merchantUsers :{};
	public checkRouting: string;
    public checkRoutingno: string;
	public phoneNumber : string;
	constructor(protected  route: ActivatedRoute, protected  router: Router, protected toastr: ToastrService, protected  userService :UserService,  protected  echexpaymentService: EchexpaymentService, protected localStorageService: LocalstorageService) { 
		this.router = router;
		let userDetails = <any>{};
		let currentUser = <any>{};
		
		currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		userDetails = this.localStorageService.getData("currentUser");
		this.user_id = userDetails._id;
	}

	ngOnInit() {
	}
  
	// Get Profile details
	getprofileDetails(){
		
		var data = {
			token:this.token,
			id:this.user_id,
		}
		var url =  this.router.url
		
		let profileData = <any>{};
		 this.busy = this.userService.getProfileData(data).subscribe(
			 response => {
			  profileData = response;
				this.profile = profileData.data;
				this.merchantImg_url = profileData.data.business_image_url;
				 this.localStorageService.setData("Mer_Profile_image", profileData.data);
				 this.profile.country_code = profileData.data.country_code ;


				var accountObj =    Helper.isEmpty(profileData.data.accounts);
				if(accountObj === false){
					this.profileBankDetails = profileData.data.accounts;
				
				} 
			  
				// Excute when sendcheck link clicked
				if(profileData.data.accounts && this.router.url === '/sendcheck'){
						this.getDefaultCheckNumber(profileData.data.accounts);
						this.sendCheck = profileData.data.accounts;
						this.sendCheck.merchantname = profileData.data.first_name;
						if(this.sendCheck.routing_number){
						this.getRoutingInfo(this.sendCheck.routing_number);
						}
						
						this.sendCheck.merchantaddress = profileData.data.address;
						this.sendCheck.merchantcity = profileData.data.city;
						this.sendCheck.merchantstate = profileData.data.state;
						this.sendCheck.merchantzipcode = profileData.data.zipcode;
						this.sendCheck.merchantemail = profileData.data.email;

				}
			  
				this.twofactorStatus = profileData.data.twofactor_status
				this.profileSettings = profileData.data.settings;
				this.profile.password ='';
				//show_edit_signature.signature
				if(this.profileBankDetails.signature){
					this.show_edit_signature = true;
					this.hide_signature_tab = false
					var str = this.profileBankDetails.signature;
					var res = str.substring(0, 14);
				 
					if(res!="data:image/png"){
					this.type_it = true;
					this.profileBankDetails.type_signature = this.profileBankDetails.signature
					}
					if(res =="data:image/png"){
						this.draw_it = true;
					}  
			
				}
			  
			 },
			 error => {
			 profileData = error;
			  this.toastr.error(profileData.error.message, 'Failed!');
			 }
		  );
		
	}
	
	//get bank details using routing number
	getRoutingInfo(routingnumber){

		if(routingnumber!= '' && routingnumber.length >=9)
		{
			 let data = {
			  user_token:this.token,
			  token:this.user_id,
			  id:this.user_id,
			  routing_number :routingnumber
			}
			let routing_response = <any>{};
			this.userService.getRoutingInfoApi(data).subscribe(
			 response => {
				routing_response = response;
				if( routing_response.status === 'error'){
					this.checkRouting = routing_response.status;
					this.checkRoutingno = 'error';
				  } else{
					this.checkRouting = '';
					this.checkRoutingno = 'Success';
				  }

				if(this.router.url === '/profile'){
					this.profileBankDetails.bank_name = routing_response.data.name;
					this.profileBankDetails.routing_number = routingnumber;
				}
				if(this.router.url === '/sendcheck'){
					this.sendCheck.bankname = routing_response.data.name;
					this.sendCheck.bankaddress = routing_response.data.address;
					this.sendCheck.bankcity = routing_response.data.city;
					this.sendCheck.bankzip = routing_response.data.zip;
				}
				if(window.location.href.indexOf("/edit-transaction") > -1){
					
					this.bankname = routing_response.data.name;
					this.bankaddress = routing_response.data.address;
					this.bankcity = routing_response.data.city;
					this.bankzip = routing_response.data.zip;
					
				}
			 }, 
			 error => {
			   routing_response = error;
			   this.toastr.error(routing_response.error.message, 'Failed!');
			 }
		  ); 
		}

	}
	
	// Get default cheque number 
	getDefaultCheckNumber(account_data){
		var data = {
			user_token: this.token,
			token: this.user_id,
			id: this.user_id,
			checking_account_number: account_data.account_number,
			routing_number: account_data.routing_number
		}
		var url =  this.router.url
		let responseData = <any>{};
		 this.busy = this.echexpaymentService.getDefaultCheckNumberApi(data).subscribe(
			 response => {
			   responseData  = response;
			   //this.check_number = responseData.data;
			   this.check_number = responseData.data === 0 ? '0001' : responseData.data;
			 },
			 error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			 }
		  );
	 }
	
	//invoke access and resend invite
	actionAccess(event,m_id, status_id){
	 event.stopPropagation();
	  var action  = '';
	  if(status_id == 0){
		action = 'resend'
	  }
	  if(status_id == 3){
		action = 'revoke'
	  }
	  var data = {
		  token:this.token,
		  user_token:this.token,
		  _id:m_id,
		  status:status_id,
		  action:action,
		}
	 let response_action = <any>{};
	 this.busy  =   this.userService.actionAccessApi(data).subscribe(
		response => {
			response_action = response;
			this.toastr.success(response_action.message, 'Success!');
			this.getMerchantUsers();
		},
		error => {
			response_action = error;
			this.toastr.error(response_action.error.message, 'Failed!');		}
	  );
	}

	// get user by merchant
	getMerchantUsers(){
		var data = {
			token:this.token,
			id:this.user_id,
		}
		var url =  this.router.url;
		let response_users = <any>{};
		this.busy = this.userService.getMerchantUsersAPI(data).subscribe(
			response => {
			response_users = response;
			this.merchantUsers = response_users.data;
			//   if(response_users.data.length == 0){
			// 	 this.dataNotFound =  response_users.message;
			//    }
		
			},
			error => {
				response_users = error;
				this.toastr.error(response_users.error.message, 'Failed!');
			}
		);
	}
	
	// Update permission
	updatePermission(model){

		var permissionArray = {}; 
		var permissionArrayNew = {};
		model.Dashboard = true;
		for (let key in model) {
			permissionArray[key] = (model[key])?'yes':'no';
		}

		let params: any = this.route.snapshot.params;
		let data = {
		  token:params.id,
		  user_token:this.token,
		  id:params.id,
		  role_id:params.role_id,
		  permissions:permissionArray
		}
		
		let responseData = <any>{};
		this.busy = this.echexpaymentService.updateUserPermission(data).subscribe(
		   response => {
		    responseData = response;
			var url = "";
			if(params.role_id == 2){
			 url = "/echex-admin";
			}
			if(params.role_id == 3){
			 url = "/echex-merchant";
			}
			
			if(params.role_id == 4){
				let userDetails = <any>{};
				userDetails = this.localStorageService.getData("currentUser");
				if(userDetails.role_id == 1) {
					url = "/casherpay-users";
				} else {
					url = "/profile";
				}
			}
			this.toastr.success(responseData.message, 'Success!');
			this.router.navigate([url]);
		 
		   },
		   error => {
			 responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);  
	}
	

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexbase/echexbase.component.ts